import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import './App.css';
import { LandingPage } from './pages/LandingPage/LandingPage';

export default function App() {
  return (
    <BrowserRouter>
      <LandingPage />
    </BrowserRouter>
  );
}
